
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ModalBox extends Vue {
    @Prop() templateBodyInstance!: Vue
    @Prop() titleTranslationKey!: string
    @Prop() closeCallback: undefined | (() => void)

    mounted (): void {
        this.mountSubComponent()
    }

    mountSubComponent (): void {
        const dynamicContent = this.$refs.dynamicContent as HTMLElement
        this.templateBodyInstance.$mount()
        dynamicContent.appendChild(this.templateBodyInstance.$el)
    }

    removeSubComponent () {
        const dynamicContent = this.$refs.dynamicContent as HTMLElement
        if (dynamicContent && dynamicContent.lastChild) {
            dynamicContent.removeChild(dynamicContent.lastChild)
            this.templateBodyInstance.$destroy()
        }
    }

    beforeDestroy (): void {
        this.removeSubComponent()
    }

    closeModal () {
        if (typeof this.closeCallback === 'function') {
            this.closeCallback()
        }
    }
}
